import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { QualityControlMonthlyContainerModel } from "../../../../../../../models/aggregates/alg/cc/quality-control/quality-control-monthly-container.model";
import { ApiVisa, Pagination } from "../../../shared";
import { BaseApiTemplateService } from "../../../shared/base-api-template-service.model";
import { Core2Config } from "../../../shared/core2Config";

@Injectable({
	providedIn: "root",
})
export class QualityControlMonthlyService extends BaseApiTemplateService<QualityControlMonthlyContainerModel> {
	readonly url =
		Core2Config.TENANT_DOMAIN_URL_PREFIX +
		Core2Config.ALG_CC_MODULE +
		"qc/monthly";

	constructor(http: HttpClient) {
		super();
		this.apiUrl =
			Core2Config.DOMAIN_URL +
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.ALG_CC_MODULE +
			"qc/monthly";
		this.endpoint_path =
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.ALG_CC_MODULE +
			"qc/monthly";
		this.httpClient = http;
	}

	public generateLines(
		pagination: Pagination,
		dtoObject : QualityControlMonthlyContainerModel,
		visa: ApiVisa,
	  ) {
		if (this.endpoint_path && visa.api_domain_url) {
		  this.apiUrl = visa.api_domain_url + this.endpoint_path;
		}
		const UrlByCriteria =
		  this.apiUrl + '/generate-lines?' + this.getQueryParams(pagination);
		return this.httpClient.post(
		  UrlByCriteria,
		  dtoObject,
		  this.getHttpHeader(visa)
		);
	  }
	
	public getQueryParams(pagination : Pagination) {
	  let buffer = String('');
	  for (let a = 0; a < pagination.conditionalCriteria.length; a++) {
		if (a > 0) {
		  buffer = buffer + '&';
		}
		buffer +=
		  pagination.conditionalCriteria[a].columnName +
		  pagination.conditionalCriteria[a].operator +
		  pagination.conditionalCriteria[a].value;
	  }
	  return buffer;
	}
}
